import { PosBillingModals } from '@/components/pos/billing/PosBillingModals';
import { PosCartPane } from '@/components/pos/billing/PosCartPane';
import { PosOfflineQueueBanner } from '@/components/pos/billing/PosOfflineQueueBanner';
import { isPosOfflineModeEnabled } from '@/utils/posOffline';
import { PosProductPane } from '@/components/pos/billing/PosProductPane';
import { PosStatusBar } from '@/components/pos/billing/PosStatusBar';
import { PosSummaryPane } from '@/components/pos/billing/PosSummaryPane';
import { useAppSelector } from '@/hooks/useAppSelector';
import { formatCurrency } from '@/utils/format';
import { PosBillingProvider } from './PosBillingContext';

export function PosBillingScreen() {
  const store = useAppSelector((s) => s.app.selectedStore);
  const currencyCode = store?.currencyCode ?? 'INR';
  const fmt = (amount: number | string | null | undefined) => formatCurrency(amount, currencyCode);

  if (!store) {
    return (
      <div className="flex h-full items-center justify-center text-slate-500">
        Select a store before opening POS.
      </div>
    );
  }

  return (
    <PosBillingProvider fmt={fmt}>
      <div className="flex h-full flex-col bg-slate-200 dark:bg-slate-950">
        {isPosOfflineModeEnabled() && <PosOfflineQueueBanner />}
        <div className="flex min-h-0 flex-1">
          <PosProductPane />
          <div className="flex min-w-0 flex-[1_1_58%] flex-col lg:flex-[1_1_62%]">
            <PosCartPane />
          </div>
          <PosSummaryPane />
        </div>
        <PosStatusBar />
        <PosBillingModals />
      </div>
    </PosBillingProvider>
  );
}
